// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.custom-table .ant-table-tbody > tr > td {
    padding: 4px 8px; /* Adjust the padding as needed */
}

.custom-table .ant-table-thead > tr > th {
    padding: 4px 8px; /* Adjust the padding as needed */
    height: 24px; /* Adjust the height as needed */
}

.import-scans-header {
    text-align: center;
    height: 5vh;
}

.ant-progress-show-info .ant-progress-outer {
      width: 95px !important;
  }`, "",{"version":3,"sources":["webpack://./src/asset/style/import_scans.css"],"names":[],"mappings":";AACA;IACI,gBAAgB,EAAE,iCAAiC;AACvD;;AAEA;IACI,gBAAgB,EAAE,iCAAiC;IACnD,YAAY,EAAE,gCAAgC;AAClD;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;MACM,sBAAsB;EAC1B","sourcesContent":["\n.custom-table .ant-table-tbody > tr > td {\n    padding: 4px 8px; /* Adjust the padding as needed */\n}\n\n.custom-table .ant-table-thead > tr > th {\n    padding: 4px 8px; /* Adjust the padding as needed */\n    height: 24px; /* Adjust the height as needed */\n}\n\n.import-scans-header {\n    text-align: center;\n    height: 5vh;\n}\n\n.ant-progress-show-info .ant-progress-outer {\n      width: 95px !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
